const FeedBack=(props)=>{
    return(<>
    <span {...props}>{props.error}</span>
    </>)
}

export default FeedBack;